import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Card!=!/vercel/path0/node_modules/antd/es/index.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/center/Points/index.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/layout/center-layout.tsx")